import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setShowPoint } from '../../services/controllers/common/CommonSlice';
import { selectShowPoint } from '../../services/controllers/common/CommonSelector';
import './ModalPoint.scss';
import Button, { ButtonType } from '../Button/Button';
import Icon, { ICONS } from '../SVG/Icon';
import reward2 from '../../common/assets/images/1_6.gif';

const ModalPoint: React.FC = () => {
  const dispatch = useDispatch();
  const gifStatus = useSelector(selectShowPoint);
  const onClose = () => {
    dispatch(
      setShowPoint({
        ...gifStatus,
        visible: false,
      }),
    );
  };
  const rewardGifClasses = classNames('modal3-wrapper', {
    'modal3-wrapper-active': gifStatus.visible,
  });
  const rewardGifClasses2 = classNames('modal3-overlay', {
    'modal3-overlay-active': gifStatus.visible,
  });
  return (
    <div>
      <div onClick={onClose} className={rewardGifClasses2} />
      <div className={rewardGifClasses}>
        <div className="modal3__content">
          <Icon className="modal3__close" onClick={onClose} component={ICONS.CLOSE_ICON} />
          <div className="modal3__title modal3__ftpoint">
            <div>
              <span>{gifStatus.points}</span>점 획득
            </div>
          </div>
          <div>
            <img className="modal3__image" src={reward2} alt="reward" />
          </div>
          <Button disabled={false} className="modal3__action_button" onClick={onClose} buttonType={ButtonType.Primary} fullWidth>
            네
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalPoint;
